<script>
  import View from '@/views/View'
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'Blog',

    metaInfo() {
      const baseTitle = this.$t('blog.title')
      const description = this.$t('blog.subheading')
      const { name, params } = this.$route
      let suffix = ''
      let keywords = baseTitle
      if (name === 'BlogCategory' && params.slug) {
        suffix = ` - ${params.slug}`
        keywords = `${baseTitle}, ${params.slug}`
      }
      if (name === 'BlogTag' && params.slug) {
        suffix = ` - ${params.slug}`
        keywords = `${baseTitle}, ${params.slug}`
      }
      return {
        title: `${baseTitle}${suffix}`,
        meta: [
          { vmid: 'description', name: 'description', content: description },
          { vmid: 'keywords', name: 'keywords', content: keywords },
        ],
      }
    },

    extends: View,

    mixins: [
      LoadSections([
        'hero-alt',
        'blog-list',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'blog',
      },
    },
  }
</script>
